import { useEffect, useRef } from 'react';

const row1Genres = [
  { name: 'Romance', emoji: '💝' },
  { name: 'Thriller', emoji: '🔍' },
  { name: 'Science Fiction', emoji: '🚀' },
  { name: 'Fantasy', emoji: '🐉' },
  { name: 'Mystery', emoji: '🔎' },
  { name: 'Horror', emoji: '👻' }
];

const row2Genres = [
  { name: 'Adventure', emoji: '🗺️' },
  { name: 'Historical Fiction', emoji: '📜' },
  { name: 'Literary Fiction', emoji: '📚' },
  { name: 'Biography', emoji: '👤' },
  { name: 'True Crime', emoji: '🔪' },
  { name: 'War Stories', emoji: '🎖️' }
];

const row3Genres = [
  { name: 'Poetry', emoji: '🎭' },
  { name: 'Drama', emoji: '🎬' },
  { name: 'Classics', emoji: '📖' },
  { name: 'Mythology', emoji: '⚡' },
  { name: 'Fairy Tales', emoji: '🧚' },
  { name: 'Gothic', emoji: '🏰' }
];

const row4Genres = [
  { name: 'Young Adult', emoji: '✨' },
  { name: 'Contemporary', emoji: '🌆' },
  { name: 'Dystopian', emoji: '🌍' },
  { name: 'Philosophy', emoji: '🤔' },
  { name: 'Comedy', emoji: '😄' },
  { name: 'Magical Realism', emoji: '✨' }
];

const rowGenres = [row1Genres, row2Genres, row3Genres, row4Genres];

function BackgroundBubbles() {
  const rows = [useRef(null), useRef(null), useRef(null), useRef(null)];
  
  useEffect(() => {
    const elements = rows.map(ref => ref.current);
    const positions = elements.map(() => 0);
    let animationFrameId;

    const animate = () => {
      elements.forEach((element, index) => {
        if (element) {
          // Alternate direction for each row with half speed
          const direction = index % 2 === 0 ? -0.5 : 0.5;
          positions[index] += direction;

          // Get row width for seamless loop
          const rowWidth = element.firstChild.offsetWidth;
          
          // Reset position for seamless loop
          if (direction < 0 && positions[index] <= -rowWidth) {
            positions[index] = 0;
          } else if (direction > 0 && positions[index] >= 0) {
            positions[index] = -rowWidth;
          }

          element.style.transform = `translateX(${positions[index]}px)`;
        }
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 flex flex-col justify-start pt-32 sm:pt-40 gap-4 sm:gap-6 opacity-40">
        {rows.map((ref, rowIndex) => (
          <div key={rowIndex} className="overflow-hidden">
            <div
              ref={ref}
              className="whitespace-nowrap"
              style={{ willChange: 'transform' }}
            >
              {/* Two copies of content for seamless loop */}
              <div className="inline-block">
                {[...rowGenres[rowIndex], ...rowGenres[rowIndex], ...rowGenres[rowIndex]].map((genre, index) => (
                  <div
                    key={`${index}-1`}
                    className="px-2 sm:px-3 py-1 sm:py-1.5 mx-1 sm:mx-1.5 inline-flex items-center gap-1 sm:gap-2 text-xs sm:text-sm font-medium bg-gray-100/60 backdrop-blur rounded-full border border-gray-200/60 text-gray-600"
                  >
                    <span>{genre.emoji}</span>
                    <span>{genre.name}</span>
                  </div>
                ))}
              </div>
              <div className="inline-block">
                {[...rowGenres[rowIndex], ...rowGenres[rowIndex], ...rowGenres[rowIndex]].map((genre, index) => (
                  <div
                    key={`${index}-2`}
                    className="px-2 sm:px-3 py-1 sm:py-1.5 mx-1 sm:mx-1.5 inline-flex items-center gap-1 sm:gap-2 text-xs sm:text-sm font-medium bg-gray-100/60 backdrop-blur rounded-full border border-gray-200/60 text-gray-600"
                  >
                    <span>{genre.emoji}</span>
                    <span>{genre.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BackgroundBubbles; 